import "../../../../stylesheets/raffle";
import "../../../../stylesheets/templates/raffle/template-1";
import "../../../../stylesheets/templates/raffle/template-2";
import "../../../../stylesheets/templates/raffle/template-3";
import "../../../../stylesheets/templates/raffle/template-4";
import "../../../../stylesheets/accounts/base";
import "./index";

$(document).ready(function () {
  $(document).on("show.bs.modal", ".modal", function () {
    $(".modal-backdrop").not(":last").remove();
  });

  $(document).on(
    "click",
    '[data-toggle="modal"][href="#volunteer-stats"], [data-toggle="modal"][data-target="#volunteer-stats"]',
    function () {
      $(".modal-backdrop").not(":last").remove();
    }
  );

  $(document).on("click", "#search-tickets-button", function () {
    const campaignId = $(this).data("campaign-id");
    const email = $("#ticket-verification-email").val();
    $(".modal-results").html(`<div class="ticket-verification-loader"></div>`);
    $.ajax({
      url: `/raffle/ticket_verification?id=${campaignId}&email=${email}`,
      type: "GET",
    }).done(function (response) {
      $(".modal-results").html(
        `<p>Los tickets asociados a tu correo son:</p>
        <div class="results-ticket-container">
          <div class="results-ticket-item">${response.tickets.join('</div><div class="results-ticket-item">')}</div>
        </div>
        <p class="small-text">
          Si quieres volver a recibir esta <b>información por correo</b>, haz click <a id="send-tickets-email-button" data-campaign-id="${campaignId}">aquí</a>.
        </p>`);
    }).fail(function (error) {
      $(".modal-results").html(`<p style="color: #FF5F57;">${error.responseJSON.error}</p>`);
    });
  });

  $(document).on("submit", "#ticket-verification form", function (e) {
    e.preventDefault();
    $("#search-tickets-button").trigger("click");
  });

  $(document).on("click", "#send-tickets-email-button", function () {
    const campaignId = $(this).data("campaign-id");
    const email = $("#ticket-verification-email").val();
    $(".small-text").html(`<div class="ticket-verification-loader"></div>`);
    $.ajax({
      url: `/raffle/send_raffle_tickets_email?campaign_id=${campaignId}&email=${email}`,
    }).done(function (response) {
      $(".small-text").html(`Si quieres volver a recibir esta <b>información por correo</b>, haz click <a id="send-tickets-email-button" data-campaign-id="${campaignId}">aquí</a>.`);
      alert(response.success);
    }).fail(function (error) {
      $(".small-text").html(`Si quieres volver a recibir esta <b>información por correo</b>, haz click <a id="send-tickets-email-button" data-campaign-id="${campaignId}">aquí</a>.`);
      alert('Ha ocurrido un error: ' + error.responseJSON.error);
    });
  });

  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.get("volunteer_stats") === "true") {
    $(".volunteer-stats").trigger("click");
  }

  $("#cancel-alert-high-price-button").on("click", function (e) {
    e.preventDefault();
    $("#confirm-alert-high-price-field").val("");
    $("#alert-high-price-form").modal("hide");
    var $desktop = $("#product-quantity-desktop");
    var $mobile = $("#product-quantity-mobile");
    if ($desktop.length) {
      $desktop.val("0");
      $desktop.trigger("change");
    }
    if ($mobile.length) {
      $mobile.val("0");
      $mobile.trigger("change");
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
});
